import React from "react";
import ReactDOM from "react-dom/client";
import "@webgis/shared/tokens.css";
import "./styles/base.css";
import { App } from "./App";
import { useStore } from "./store/useStore";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

/**
 * Landeroute nach dem ersten Bildaufbau anwaermen.
 *
 * Warum HIER und nicht bei den Knoepfen: der Vorgriff an Kopfleiste, Umschalter
 * und Kommandoleiste (s. app/ProjectSwitcher) braucht jemanden, der zeigt oder
 * tabbt — beim allerersten Laden zeigt niemand. Genau dort steht aber die
 * laengste Kette: "/" fuehrt auf /project/:id, und dessen Chunk zieht echarts
 * (431 KB gzip) als VIERTE serielle Stufe nach. Ihn neben dem ersten
 * Bildaufbau zu holen, nimmt eine ganze Stufe aus der Kette. Doppelt gebaut
 * wird nichts: die Knopf-Handler sind der Weg fuer spaetere Wechsel, das hier
 * ist der Weg fuer den Kaltstart.
 *
 * Drei Bedingungen, alle drei aus Ruecksicht:
 *  1. Nur mit Sitzung im Speicher — sonst landet der Besuch auf /login und der
 *     Chunk waere ein Megabyte fuer nichts.
 *  2. Nur auf der Landeroute — wer /karte oder /admin direkt aufruft, braucht
 *     die Diagramme nicht.
 *  3. Nicht im Datensparmodus und nicht auf 2g/3g. Der Vorgriff ist Komfort;
 *     auf einer schmalen Leitung nimmt er dem echten Inhalt die Bandbreite weg.
 */
function landerouteAnwaermen(): void {
  const pfad = window.location.pathname;
  if (pfad !== "/" && !pfad.startsWith("/project")) return;
  if (!useStore.getState().auth) return;
  const netz = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
  if (netz?.saveData) return;
  if (netz?.effectiveType && ["slow-2g", "2g", "3g"].includes(netz.effectiveType)) return;
  // Modulkennung WOERTLICH wie das lazy() in App.tsx — sonst zoege Vite einen
  // zweiten Chunk statt denselben vorzuziehen.
  void import("./screens/dashboard/ProjectStats").catch(() => undefined);
}

/** requestIdleCallback kennt Safari bis heute nicht — dort tut es ein Timer.
 *  Das Ziel ist in beiden Faellen dasselbe: erst der Inhalt, dann der Vorrat. */
function nachLeerlauf(fn: () => void): void {
  const ric = (window as Window & { requestIdleCallback?: (cb: () => void, opt?: { timeout: number }) => number }).requestIdleCallback;
  if (typeof ric === "function") ric(fn, { timeout: 2000 });
  else window.setTimeout(fn, 1200);
}

nachLeerlauf(landerouteAnwaermen);
